module.exports = __webpack_public_path__ + "static/grid-31aabd8a0defe297516eab6e83f6a6a8.pdf";